<section class="notification-container">
    <div class="page-title" fxLayout="row" fxLayoutAlign="space-between center">
        <div>Notifications</div>
        <button mat-stroked-button class="notification-button" (click)="markAllAsRead(this.notificationArray)">
            Mark All As Read
        </button>
    </div>
    <div class="notification-panel">
        <mat-tab-group [(selectedIndex)]="selectedIndex" (selectedIndexChange)="changeTab()">
            <mat-tab label="All">
                <ng-template mat-tab-label>
                    All
                </ng-template>
                <div *ngIf="isLoading">
                   <app-loading></app-loading>
                </div>
                <div class="notification-flex-column">
                    <div *ngFor="let notificationItem of notificationArray; let i = index">
                        <app-notification-item (reduceUnreadCount)="reduceUnreadCount()" [notificationItem]="notificationItem">
                        </app-notification-item>
                    </div>
                </div>
                <mat-paginator [length]="this.length" [pageIndex]="this.pageIndex" [pageSize]="this.pageSize" [pageSizeOptions]="this.pageSizeOptions"
                    (page)="this.getNotification('',25,$event)">
                </mat-paginator>
            </mat-tab>
            <mat-tab label="Unread">
                <ng-template mat-tab-label>
                    <div [matBadgeHidden]="this.notificationService.unreadNotificationCount == 0" matBadge="{{this.notificationService.unreadNotificationCount}}"
                        matBadgeOverlap="false">Unread</div>
                </ng-template>
                <div class="notification-flex-column">
                    <div *ngFor="let notificationItem of notificationArray; let i = index">
                        <div *ngIf="this.notificationService.getCurrentReceiver(this.notificationItem.notificationReceivers)?.status === 0">
                            <app-notification-item (reduceUnreadCount)="reduceUnreadCount()" [notificationItem]="notificationItem">
                            </app-notification-item>
                        </div>
                    </div>
                </div>
                <mat-paginator [length]="this.length" [pageIndex]="this.pageIndex" [pageSize]="this.pageSize" [pageSizeOptions]="this.pageSizeOptions"
                    (page)="this.getNotification(0,25,$event)">
                </mat-paginator>
            </mat-tab>
        </mat-tab-group>
    </div>
</section>